import { X } from "lucide-react";

export const VendorMediaItem = ({ url, orientation, onOpen }) => {
  // Heuristic: anything ending in a video extension is a video.
  const isVideo = /\.(mp4|mov|webm|m4v)(\?.*)?$/i.test(url);
  const aspect = orientation === "landscape" ? "aspect-[4/3]" : "aspect-[3/4]";
  return (
    <button
      type="button"
      data-testid={`vendor-media-thumb-${url}`}
      onClick={() => onOpen(url, isVideo)}
      className={`relative ${aspect} overflow-hidden border border-[var(--ld-ink)]/15 bg-[var(--ld-ink)]/5 group focus:outline-none focus:ring-2 focus:ring-[var(--ld-gold-deep)]`}
    >
      {isVideo ? (
        <>
          <video
            src={url}
            muted
            playsInline
            preload="metadata"
            className="h-full w-full object-cover"
          />
          <span className="absolute bottom-1 left-1 inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] tracking-[0.18em] uppercase bg-[var(--ld-ink)]/85 text-[var(--ld-gold)]">
            Video
          </span>
        </>
      ) : (
        <img
          src={url}
          alt=""
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
        />
      )}
    </button>
  );
};

export const VendorMediaLightbox = ({ item, items, onChange, onClose }) => {
  if (!item) return null;
  const idx = items.indexOf(item.url);
  const total = items.length;
  const goPrev = () => {
    const next = items[(idx - 1 + total) % total];
    const isVid = /\.(mp4|mov|webm|m4v)(\?.*)?$/i.test(next);
    onChange({ url: next, isVideo: isVid });
  };
  const goNext = () => {
    const next = items[(idx + 1) % total];
    const isVid = /\.(mp4|mov|webm|m4v)(\?.*)?$/i.test(next);
    onChange({ url: next, isVideo: isVid });
  };
  return (
    <div
      role="dialog"
      data-testid="vendor-media-lightbox"
      className="fixed inset-0 z-[60] bg-[var(--ld-ink)]/90 flex flex-col"
      onClick={onClose}
    >
      <div className="flex items-center justify-between px-6 py-4 text-[var(--ld-gold)]">
        <span className="font-accent text-[11px] tracking-[0.25em]">
          {idx + 1} / {total}
        </span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          aria-label="Close"
          className="p-1 hover:text-[var(--ld-ivory)] transition-colors"
        >
          <X size={20} strokeWidth={1.6} />
        </button>
      </div>
      <div
        className="flex-1 flex items-center justify-center px-4 pb-8 gap-3"
        onClick={(e) => e.stopPropagation()}
      >
        {total > 1 && (
          <button
            type="button"
            onClick={goPrev}
            aria-label="Previous"
            data-testid="vendor-media-prev"
            className="text-[var(--ld-gold)] hover:text-[var(--ld-ivory)] text-3xl font-light px-3"
          >
            ‹
          </button>
        )}
        <div className="max-h-full max-w-[min(90vw,1100px)]">
          {item.isVideo ? (
            <video
              key={item.url}
              src={item.url}
              controls
              autoPlay
              className="max-h-[80vh] max-w-full"
            />
          ) : (
            <img
              key={item.url}
              src={item.url}
              alt=""
              className="max-h-[80vh] max-w-full object-contain"
            />
          )}
        </div>
        {total > 1 && (
          <button
            type="button"
            onClick={goNext}
            aria-label="Next"
            data-testid="vendor-media-next"
            className="text-[var(--ld-gold)] hover:text-[var(--ld-ivory)] text-3xl font-light px-3"
          >
            ›
          </button>
        )}
      </div>
    </div>
  );
};
